module.exports = __webpack_public_path__ + "static/media/joyce_jeoung.bfff2bb7.png";